const translator = {
  more: 'بیش از',
  slider1Title: 'المپیادهای آزمایشی آیریسک',
  slider1SubTitle: 'مسیر جادویی المپیاد با بهترین‌های ایران',
  slider1Text:
    'لذت حل کردن سؤالاتی که توسط اساتید دانشگاه، مدال‌آوران المپیاد و مؤلفین منابع طرح شده به همراه رقابت با بهترین‌های ایران',
  slider2Title: 'جایزه بارونِ آیریسک',
  slider2SubTitle: 'با جمع کردن ایکس‌پول، علمت ثروت میشه',
  slider2Text:
    'با هر فعالیت موفق در سامانه آزمون و آموزش آیریسک، ایکس‌پول بگیر. بعداً باهاش هر چی دوست داری بخر یا بنیه‌ی المپیادت رو قوی‌تر کن',
  slider3Title: 'هر کجای ایران که هستی، حقّت رو بگیر',
  slider3SubTitle: 'آیریسک برای همه‌ی بچه‌های ایران',
  slider3Text:
    'مثل ما هستی یا خیلی پولداری؟ کسی تو مدرسه‌ات نمی‌دونه المپیاد چیه؟ تازه‌کاری یا داری برای جهانی می‌خونی؟ هر کجا هستی، بیا که چند قدم جلوتر بریم',
};
export default translator;
